import PropTypes from 'prop-types';
import React from 'react';

import Assets from '@app/assets';
import Illustration from '@component/illustration';

export default class VideoIllustration extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    variants: PropTypes.number,
    src: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
  };

  static defaultProps = {
    variants: 0,
  };

  state = {
    error: false,
    loading: true,
  };

  constructor(props) {
    super(props);

    this.showFallback = this.showFallback.bind(this);
    this.showVideo = this.showVideo.bind(this);
  }

  showVideo() {
    if (this.state.loading) {
      this.setState({ error: false, loading: false });
    }
  }

  showFallback() {
    this.setState({ error: true, loading: false });
  }

  render() {
    if (this.state.error) {
      return (
        <Illustration
          type={this.props.type}
          variants={this.props.variants}
          className={this.props.className}
        />
      );
    }

    const random = Illustration.getRandomIllustration(this.props.variants);
    let sourceFile = this.props.src;

    if (this.props.variants > 1) {
      sourceFile = `${sourceFile}-${random}`;
    }

    const src = Assets.lookup(`${sourceFile}.mp4`);

    // Compose the className
    const classNames = ['illustration'];
    if (this.props.className) {
      classNames.push(this.props.className);
    }

    if (this.state.loading) {
      classNames.push('illustration--loading');
    }

    // Render video illustration with regular illustrations as a fallback
    return (
      <video
        ref={(node) => (this.videoNode = node)}
        className={classNames.join(' ')}
        autoPlay="autoplay"
        loop="loop"
        muted="muted"
        playsInline="playsinline"
        webkit-playsinline="webkit-playsinline"
        preload="auto"
        onError={this.showFallback}
        onCanPlay={this.showVideo}
        onLoadedMetadata={this.showVideo}
      >
        <source src={src} type="video/mp4" />
      </video>
    );
  }
}
